import { Race } from '@api/types';
import { Status } from '@features/Meeting/components/RacesTab/components/RacesList/components/RaceStatus';

const adaptRaceStatus = (raceStatusCode: Race['raceStatus']): Status | null => {
  switch (raceStatusCode) {
    case '01':
    case '1':
      return 'stopped';
    case '08':
    case '8':
      return 'ongoing';
    case '10':
    case '11':
    case '12':
    case '13':
    case '14':
    case '15':
    case '16':
      return 'ended';
    case '17':
      return 'cancelled';
    default:
      return 'upcoming';
  }
};

export { adaptRaceStatus, type Status };
